var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0015 2C3.61058 2 2.479 3.13035 2.479 4.51973C2.479 5.90973 3.61058 7.04051 5.0015 7.04051C6.39131 7.04051 7.52197 5.90966 7.52197 4.51973C7.52203 3.13035 6.39131 2 5.0015 2ZM6.91144 8.10506H3.08875C2.91909 8.10506 2.78162 8.24259 2.78162 8.41218V20.6928C2.78162 20.8625 2.91909 21 3.08875 21H6.91144C7.08109 21 7.21856 20.8625 7.21856 20.6928V8.41218C7.21856 8.24259 7.08109 8.10506 6.91144 8.10506ZM13.2761 9.20975C13.9645 8.4598 15.0994 7.79979 16.6348 7.79979C20.9404 7.79979 21.5209 10.9122 21.5209 13.9567V20.6929C21.5209 20.8625 21.3834 21 21.2138 21H17.398C17.2284 21 17.0909 20.8625 17.0909 20.6929V14.7221C17.0909 13.0503 16.9674 11.7716 15.4129 11.7716C13.9857 11.7716 13.4295 12.5692 13.4295 14.6167V20.6928C13.4295 20.8625 13.292 20.9999 13.1224 20.9999H9.30806C9.1384 20.9999 9.00093 20.8625 9.00093 20.6928V8.41214C9.00093 8.24254 9.1384 8.10501 9.30806 8.10501H12.969C13.1386 8.10501 13.2761 8.24254 13.2761 8.41214V9.20975Z",
    fill: "#B5BEED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.432c4fbc996c5e15112d7d343a236db9.svg";
export { ForwardRef as ReactComponent };